import type { FaireProductEntity } from "../../entity_types/product";

export const p_qdvwsr2pxw: FaireProductEntity = {
  token: "p_qdvwsr2pxw",
  type: "product",
  name: "Game Day Knit Women's Sweater - Mommy and Me - Football",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/6bfcba83f01926353dc6cb6c28bd0fad19d39ea1ca44aad8584392d1246639d0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/459fbb998d869684e6d64b3d84104b9a7d77eac208e143a943bc185c9d6c3287.jpeg",
    "https://cdn.faire.com/fastly/8e2a46a3a714143cecc5e21f9d2d86d6bedec46f6d066472811bbfbe9b870112.jpeg",
  ],
  priceDollars: 34,
  description:
    "The Game Day Knit Women's Sweater, now with new and improved sizing, is a fun and cute sweater for celebrating Game Day!\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Sweater Color: Natural\n• Embroidery Color: Brown with a brown chenille football patch\n• Material: 100% Acrylic\n• Fit: Moderately oversized\n• Care: Hand wash only, do not iron, tumble dry, bleach or dry clean\n\nEach sweater is packed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:27.129Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
